import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Chip, TextField } from '@mui/material';

const InventoryBarcodesForm = ({
  label = 'Barcodes',
  readOnly = false,
  value = [],
  setBarcodeNumber = () => {},
  setIsDirty = () => {},
  setIsValid = () => {},
}) => {
  const { t } = useTranslation();
  const [barcodes, setBarcodes] = useState(value);
  const [inputValue, setInputValue] = useState('');

  const handleAddItem = (event) => {
    if (readOnly) return;

    const newValue = event.target.value;
    if (
      (event.key === ',' || event.key === 'Enter') &&
      newValue.trim() !== ''
    ) {
      const newBarcodes = [newValue.trim(), ...barcodes];
      setBarcodes(newBarcodes);
      setBarcodeNumber(newBarcodes);
      setInputValue('');
      setIsDirty(true);
      setIsValid(true);
      event.preventDefault(); // Prevent newline in TextField
    }
  };

  const handleChange = (_, newValue) => {
    if (readOnly) return;
    setBarcodes(newValue);
    setBarcodeNumber(newValue);
    setIsDirty(true);
    setIsValid(true);
  };

  return (
    <Autocomplete
      multiple
      size="small"
      id="inventory-barcodes"
      options={[]}
      value={barcodes}
      freeSolo
      disableClearable={readOnly}
      onChange={handleChange}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        if (!readOnly) setInputValue(newInputValue);
      }}
      onKeyDown={handleAddItem}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={index}
            variant="outlined"
            sx={{ background: '#ebebeb', border: 'none' }}
            label={option}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label || t('Enter Barcodes')}
          InputLabelProps={{ shrink: true }}
          inputProps={{
            ...params.inputProps,
            readOnly: readOnly,
          }}
          onChange={(event) => {
            if (readOnly) return;

            const valueWithComma = event.target.value.split(',');
            if (valueWithComma.length > 1 && event.target.value !== ',') {
              const newBarcodes = [...valueWithComma, ...barcodes];
              setBarcodes(newBarcodes);
              setBarcodeNumber(newBarcodes);
              setInputValue('');
            } else {
              setInputValue(event.target.value);
            }
          }}
        />
      )}
      sx={{ width: '100%', mr: 2 }}
    />
  );
};

export default InventoryBarcodesForm;
